export default {
  noSamePass: 'Senha e senha de confirmação não correspondem',
  loginSuccess: 'Login bem-sucedido',
  registerSuccess: 'Registro bem-sucedido',
  isHaveAccount: 'Já tem conta?',
  login: 'Login',
  logout: 'Logout',
  forgetPass: 'Esqueceu a senha?',
  register: 'Registrar',
  registered: 'Já registrado, ',
  pwdErr: 'A senha que você inseriu está incorreta.',
  emailTips: 'E-mail',
  password: 'Senha',
  confirmPass: 'Confirmar senha',
  countryTips: 'Por favor, selecione o país',
  inviteCodeTips: 'Por favor, insira o código de convite (opcional)',
  verifyEmpty: 'As informações inseridas não podem estar vazias',
  verifyEmail: 'Por favor, insira o formato de e-mail correto',
  verifyUrl: 'Por favor, insira o formato de URL correto',
  verifyPass: 'A senha deve ter 6-20 caracteres e deve conter letras e números',
  confirmText: 'Li e concordo',
  verifyCode: 'Código de verificação',
  loginPwd: 'Senha de login',
  editPwd: 'Modificar senha',
  changePwd: 'Alterar senha',
  setPwd: 'Definir senha',
  and: 'e',
  privacyStatement: '《Declaração de Privacidade》',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  editSuccess: 'Modificado com sucesso',
  email: 'E-mail',
  emailCode: 'Código de verificação de e-mail',
  newPwd: 'Nova senha',
  button: {
    search: 'Pesquisar',
    query: 'Consultar imediatamente',
    reset: 'Redefinir',
    submit: 'Enviar',
    submitOrder: 'Enviar pedido',
    save: 'Salvar',
  },
  holder: {
    select: 'Por favor, selecione',
    startTime: 'Hora de início',
    endTime: 'Hora de término',
    max: 'Máximo',
    min: 'Mínimo',
    inputContent: 'Por favor, insira o conteúdo',
    inputEmailAccount: 'Por favor, insira o endereço de e-mail correto',
  },
  back: 'Bem-vindo de volta!',
  continueGoogle: 'Continuar com Google',
  notAccount: 'Ainda não tem conta?',
  signNow: 'Registrar agora',
  termService: 'Termos de Serviço',
  privacyPolicy: 'Política de Privacidade',
  helpCenter: 'Centro de Ajuda',
  readPrivacy: 'Li e aceito',
  verifyAccept: 'Ainda não aceitou o acordo',
  accountSecurity: 'Segurança da conta',
  loginNow: 'Fazer login agora',
  resetPsd: 'Redefinir senha',
  verifiedEmail: 'Verificar e-mail',
  unverified: 'Não verificado',
  emailVerification: 'Verificação de e-mail',
  verifyMsg:
    'Seu e-mail ainda não foi verificado, portanto, não podemos concluir operações de compra temporariamente. Por favor, verifique seu e-mail no centro pessoal.',
  sendVerificationEmail: 'Enviar e-mail de verificação',
  linkHasExpired: 'O link expirou!',
  hasSendEmail: 'E-mail de verificação enviado!',
  shippingFeeEstimation: 'Estimativa de frete',
  homeText: 'Início',
  loginBgMsg: 'Junte-se ao Discord acbuy para mais benefícios',
  registerTitleMsg: 'Comece sua jornada',
  registerBgMsg: 'Novos usuários registrados podem obter cupom de frete de {coupon}+',
  announcement: 'Anúncio',
  formAnnouncementMsg:
    'Um novo modelo de programa de afiliados, modelo de comissão de dois pacotes, use-o para ganhar dinheiro e economizar',
  incorrectAmount: 'O valor do saque deve ser maior que 0',
  uniOrderAgreeText:
    'Os links enviados nesta página pertencem a links de produtos de terceiros (como Xianyu, Xiaohongshu, Bilibili, etc.). O acbuy só pode ajudá-lo a encontrar o comerciante deste link para consulta de produtos, compra e arranjo de serviços de logística de terceiros. O acbuy não pode distinguir a qualidade e autenticidade dos produtos. Você precisa assumir os riscos relevantes antes de fazer o pedido.',
  excludeFees: 'Aviso importante: O frete internacional será calculado separadamente.',
  selectProductBtn: 'Selecionar produtos do meu armazém',
}
